<script lang="ts">
  import { Button } from "sveltestrap";
  import { JobDescription, JobDescriptions, Savethisjob, Share } from "../../../../utils/Constant/Constant";
  import {jobdetaildata} from "../../../../Data/Miscellaneous/CardView"
</script>
<div class="job-description">
    <h6>{JobDescription}</h6>
    <p class="text-start">{JobDescriptions}</p>
  </div>
  {#each jobdetaildata as jobItem}
    <div class="job-description">
        <h6>{jobItem.header} </h6>
        <ul>
            {#each jobItem.detail as detailItem}
            <li>{detailItem} </li>
            {/each}
        </ul>
    </div>
  {/each}
  <div class="job-description">
    <Button color="primary">
        <span>
            <i class="fa fa-check"></i>
        </span> {Savethisjob}
    </Button>
    <Button color="primary">
        <span>
            <i class="fa fa-share-alt"></i>
        </span> {Share}
    </Button>
</div>